import { Component, Input, OnChanges, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiTranslationsHistoryService, TranslationsHistoryItem } from '../../../../shared/services/api-translationsHistory.service';

type ImportType = TranslationsHistoryItem['importType'];

interface TranslationTypeRow {
  importType: ImportType;
  label: string;
  latest: TranslationsHistoryItem | null;
}

@Component({
  selector: 'app-translation-status-card',
  imports: [CommonModule],
  templateUrl: './translation-status-card.component.html',
})
export class TranslationStatusCardComponent implements OnChanges {
  @Input({ required: true }) organizationId!: string;

  private readonly typeLabels: Record<ImportType, string> = {
    SurveyTranslations: 'Survey Translations',
    GlobalTranslations: 'Global Translations',
  };

  loading = signal(false);
  error = signal<string | null>(null);
  rows: TranslationTypeRow[] = [];

  constructor(private translationsHistoryService: ApiTranslationsHistoryService) {}

  ngOnChanges(): void {
    if (this.organizationId) this.load();
  }

  load(): void {
    this.loading.set(true);
    this.error.set(null);
    this.translationsHistoryService.getTranslationsHistory(this.organizationId, null, 'Import', 1, 50).subscribe({
      next: (result) => {
        const sorted = [...result.items].sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
        this.rows = (Object.keys(this.typeLabels) as ImportType[]).map(importType => ({
          importType,
          label: this.typeLabels[importType],
          latest: sorted.find(i => i.importType === importType) ?? null,
        }));
        this.loading.set(false);
      },
      error: (err) => {
        this.error.set('Failed to load translation status. | ' + err);
        this.loading.set(false);
      }
    });
  }
}
